import { DataLanguageApiModel } from '../../../api/users/models/data-language.api.model';

export class DataLanguageModel {
    id: number;
    languageTag: string;
    name: string;

    constructor(apiModel?: DataLanguageApiModel) {
        if (apiModel) {
            this.id = apiModel.id;
            this.languageTag = apiModel.languageTag;
            this.name = apiModel.name;
        }
    }
}
